
import {
  Obra
} from '../index';


export class ObraDetalhePOMIGO {
  "ObraId";
  "numeroDaPO";
  "vendor";
  "id";
  Obra;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraDetalhePOMIGO`.
   */
  static getModelName() {
    return "ObraDetalhePOMIGO";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraDetalhePOMIGO for dynamic purposes.
  **/
  static factory(data) {
    return new ObraDetalhePOMIGO(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraDetalhePOMIGO',
      plural: 'ObraDetalhePOMIGOs',
      path: 'ObraDetalhePOMIGOs',
      properties: {
        "ObraId": {
          name: 'ObraId',
          type: 'string'
        },
        "numeroDaPO": {
          name: 'numeroDaPO',
          type: 'string'
        },
        "vendor": {
          name: 'vendor',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        Obra: {
          name: 'Obra',
          type: 'Obra',
          model: 'Obra'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraDetalhePOMIGO.js